import { Grid, Hidden, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { SIDE_PADDING, TOP_PADDING } from "../../app/theme/muiTheme";
import Divider from "@mui/material/Divider";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import { ABOUT, CONTACT } from "../../app/api/routes";
import TwitterIcon from "@mui/icons-material/Twitter";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: TOP_PADDING,
    paddingBottom: TOP_PADDING,
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
    backgroundColor: theme.palette.primary.main,
    [theme.breakpoints.down("md")]: {
      textAlign: "center",
    },
  },
  greybg: {
    backgroundColor: theme.palette.primary.light,
  },
  nametxt: {
    fontWeight: "bold",
    fontSize: 30,
    [theme.breakpoints.down("md")]: {
      fontSize: 20,
    },
  },
  addresstxt: {
    fontSize: 18,
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },
  },
  links: {
    paddingLeft: "2%",
    paddingRight: "2%",
    "&:hover": {
      cursor: "pointer",
    },
  },
  linkstxt: {
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },
  },
  imagelinks: {
    "&:hover": {
      cursor: "pointer",
    },
    width: "30px",
    height: "30px",
  },
  icons: {
    color: theme.palette.primary.dark,
  },
  icondiv: {
    "&:hover": {
      cursor: "pointer",
    },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  wrapper: {
    justifyContent: "flex-end",
    [theme.breakpoints.down("md")]: {
      justifyContent: "center",
      paddingTop: "5%",
    },
  },
}));

const Footer = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <div
      className={clsx(classes.root, {
        [classes.greybg]: props.odd,
      })}
    >
      <Grid container>
        <Grid xs={12} md={6} item>
          <Typography className={classes.nametxt}>Dibyanshu Pandey</Typography>
          <br />
          <Typography className={classes.addresstxt}>
            B-27, Defence Colony, New Delhi-110024
            <br />
            <Hidden mdDown>© 2022 DP All rights reserved.</Hidden>
          </Typography>
        </Grid>
        <Hidden mdUp>
          <Grid container className={classes.wrapper}>
            <img src="/images/call.svg" alt="call" />
            &nbsp; &nbsp;<Typography>+91 9953810683</Typography>
            &nbsp; &nbsp; <img src="/images/mail.svg" alt="mail" />
            &nbsp; &nbsp;<Typography>info@plcoffice.com</Typography>
          </Grid>
        </Hidden>
        <Grid xs={12} md={6} item>
          <Grid container className={classes.wrapper}>
            <img
              src="/images/fb.svg"
              alt="fb"
              className={classes.imagelinks}
              onClick={() =>
                window.open(
                  "https://www.facebook.com/AdvocateDibyanshuPandey",
                  "_blank"
                )
              }
            />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <img
              src="/images/insta.svg"
              alt="insta"
              className={classes.imagelinks}
              onClick={() =>
                window.open("https://www.instagram.com/the.dibyanshu", "_blank")
              }
            />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <div
              className={classes.icondiv}
              onClick={() =>
                window.open("https://twitter.com/TheDibyanshu", "_blank")
              }
            >
              <TwitterIcon className={classes.icons} />
            </div>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <img
              src="https://www.kooapp.com/assets/2d634360.svg"
              alt="koo"
              className={classes.imagelinks}
              onClick={() =>
                window.open(
                  "https://www.kooapp.com/profile/DibyanshuPandey",
                  "_blank"
                )
              }
            />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <img
              src="images/LI-In-Bug.png"
              alt="linkedin"
              className={classes.imagelinks}
              onClick={() =>
                window.open(
                  "https://www.linkedin.com/in/dibyanshupandey/",
                  "_blank"
                )
              }
            />
          </Grid>
          <Hidden mdDown>
            <Grid container className={classes.wrapper}>
              <img src="/images/call.svg" alt="call" />
              &nbsp; &nbsp;<Typography>+91 9953810683</Typography>
              &nbsp; &nbsp; <img src="/images/mail.svg" alt="mail" />
              &nbsp; &nbsp;<Typography>info@plcoffice.com</Typography>
            </Grid>
          </Hidden>
          <Grid container className={classes.wrapper}>
            <div
              className={classes.links}
              onClick={() => {
                navigate(ABOUT);
              }}
            >
              <Typography className={classes.linkstxt}>About Me</Typography>
            </div>
            <Divider orientation="vertical" flexItem />
            <div
              className={classes.links}
              onClick={() => {
                navigate(CONTACT);
              }}
            >
              <Typography className={classes.linkstxt}>Contact</Typography>
            </div>
            <Divider orientation="vertical" flexItem />

            <div className={classes.links}>
              <Typography className={classes.linkstxt}>Privacy</Typography>
            </div>
            <Divider orientation="vertical" flexItem />

            <div className={classes.links}>
              <Typography className={classes.linkstxt}>
                Terms & Condition
              </Typography>
            </div>
          </Grid>
          <Hidden mdUp>
            <Typography className={classes.addresstxt}>
              © 2022 DP All rights reserved.
            </Typography>
          </Hidden>
        </Grid>
      </Grid>
    </div>
  );
};

export default Footer;
